import cookie from 'react-cookies';
import moment from 'moment';
import axios from 'axios';
import bcrypt from 'bcryptjs';
import { toast } from 'react-toastify';
export const restartApplication = async (projectSeo) => {
  const exchangeSurfaceUrl = process.env.REACT_APP_EXCHANGE_SURFACE;

  if (await validateLastRestartTime()) {
    try {
      const checkApplicationUrl = `https://${projectSeo}.${exchangeSurfaceUrl}script-server/status`;
      const { data: status } = await axios.get(checkApplicationUrl, {
        headers: { Authorization: `Bearer ${password}` },
      });
      if (status.success || status.success === 'true') {
        const password = await generatePassword();
        const restartUrl = `https://${projectSeo}.${exchangeSurfaceUrl}script-server/restart`;
        const { data: response } = await axios.get(restartUrl, {
          headers: { Authorization: `Bearer ${password}` },
        });
        toast.success('Application has been restarted successfully', {});
        saveRestartTime();
      } else {
        toast.error(
          `Restart Application is not available right now. Please try again after sometime`,
        );
      }
    } catch (error) {
      toast.error(`Restart Application Failed. Please try again after sometime.`);
      console.log('error', error);
    }
  } else {
    console.log("Don't make API call");
    toast.error(`Please wait for 5 minutes to restart again.`);
  }
};

export const validateLastRestartTime = async () => {
  const lastRestartTime = cookie.load('last-restart-time');
  if (!lastRestartTime) {
    return true;
  }

  const time1 = moment(lastRestartTime, 'H:mm:ss');
  const time2 = moment(moment().format(), 'H:mm:ss');
  if (time2.diff(time1, 'minutes') < 5) {
    return false;
  }
  return true;
};

export const saveRestartTime = () => {
  cookie.save('last-restart-time', moment().format(), { path: '/' });
};
export const generatePassword = async () => {
  const randomArray = [
    'pgyde',
    'ysmzc',
    'erybh',
    'qxitz',
    'dxudg',
    'zylex',
    'ebldg',
    'saapx',
    'irxrp',
    'axzhs',
  ];
  const randomNumber = Math.floor(Math.random() * randomArray.length);
  const randomString = randomArray[randomNumber];
  const salt = await bcrypt.genSalt(10);
  const hashPassword = await bcrypt.hash(randomString, salt);
  return hashPassword;
};
